const routes = [
  {
    path: "/",
    exact: true,
    component: "Home",
  },
  {
    path: "/home",
    exact: true,
    component: "Home",
  },
  {
    path: "/demo",
    exact: true,
    component: "Demo",
  },
  {
    path: "/faq",
    exact: true,
    component: "FAQ",
  }
];

export default routes;